/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Notes_Add_TitleInputs */

const en_event_notes_add_title = /** @type {(inputs: Event_Notes_Add_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add Notes`)
};

const fr_event_notes_add_title = /** @type {(inputs: Event_Notes_Add_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter des notes`)
};

const de_event_notes_add_title = /** @type {(inputs: Event_Notes_Add_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notizen hinzufügen`)
};

const it_event_notes_add_title = /** @type {(inputs: Event_Notes_Add_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi note`)
};

const ru_event_notes_add_title = /** @type {(inputs: Event_Notes_Add_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавить примечания`)
};

const es_event_notes_add_title = /** @type {(inputs: Event_Notes_Add_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar notas`)
};

const zh_cn2_event_notes_add_title = /** @type {(inputs: Event_Notes_Add_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加备注`)
};

const ja_event_notes_add_title = /** @type {(inputs: Event_Notes_Add_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メモを追加`)
};

const hi_event_notes_add_title = /** @type {(inputs: Event_Notes_Add_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नोट्स जोड़ें`)
};

const pt_pt2_event_notes_add_title = /** @type {(inputs: Event_Notes_Add_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar notas`)
};

/**
* | output |
* | --- |
* | "Add Notes" |
*
* @param {Event_Notes_Add_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_notes_add_title = /** @type {((inputs?: Event_Notes_Add_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Notes_Add_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_notes_add_title(inputs)
	if (locale === "de") return de_event_notes_add_title(inputs)
	if (locale === "it") return it_event_notes_add_title(inputs)
	if (locale === "ru") return ru_event_notes_add_title(inputs)
	if (locale === "es") return es_event_notes_add_title(inputs)
	if (locale === "zh-CN") return zh_cn2_event_notes_add_title(inputs)
	if (locale === "ja") return ja_event_notes_add_title(inputs)
	if (locale === "hi") return hi_event_notes_add_title(inputs)
	if (locale === "pt-PT") return pt_pt2_event_notes_add_title(inputs)
	return en_event_notes_add_title(inputs)
});